<template>
  <div class="pa-section-panel-title">
    <div class="pa-title">{{title}}</div>
    <div class="pa-caption">{{caption}}</div>
  </div>
</template>

<script>
export default {
  props : {
    title: {
      default: null
    },
    caption: {
      default: null
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-section-panel-title{
  width:98%;
  margin:.3rem auto;
  background-color: #C2A78F;
  border-radius: 4px;
  
  .pa-title{
    font-weight: normal;
    color:#8E5B17;
    text-align: center;
    margin:0;
    padding:.2rem .5rem 0;
    font-size:1.5rem;
    user-select: none;
    font-family: 'mplus-1m-regular';
  }

  .pa-caption{
    text-align: center;
    width:95%;
    margin:0 auto;
    padding:.2rem 0 .1rem;
    color:#7C5E49;
    font-size: .85rem;
    border-top:2px solid #C6AC97;
    user-select: none;
  }

  @media screen and (min-width: $desktop) {
    margin:12px auto;

    .pa-title{
      padding:8px 6px 2px;
      font-size:1.9rem;
    }

    .pa-caption{
      padding:6px 0 4px;
      font-size:1rem;
    }
  }
}
</style>